import { AxiosError } from 'axios';
import { useMutation, UseMutationResult } from 'react-query';
import { api } from '../api';
import queryClient from '../query-client';
import { COASyncReport, ManualCOAInput } from '../types/entity';
import { IntegrationError } from '../types/errors/integration-error';

async function syncChart(entityId: string, chartId: string, accounts?: ManualCOAInput): Promise<{ results: COASyncReport }> {
    const { data } = await api.post(`/entities/${entityId}/charts/${chartId}/sync`, accounts);
    return data;
}

export function useSyncEntityChart(
    entityId: string
): UseMutationResult<
    { results: COASyncReport },
    AxiosError<IntegrationError | { message: string }>,
    { chartId: string; accounts?: ManualCOAInput },
    unknown
> {
    return useMutation((params: { chartId: string; accounts?: ManualCOAInput }) => syncChart(entityId, params.chartId, params.accounts), {
        onSettled: () => {
            queryClient.invalidateQueries(['entities', entityId, 'charts']);
            queryClient.invalidateQueries(['workpapers']);
        },
    });
}
